import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, CircularProgress, Paper } from '@mui/material'
import { useParams } from 'react-router-dom'
import { PDFViewer } from '../../../components/PDFViewer'
import { viewUserManual } from '../../../redux/actions/UserManualAction/UserManualAction'
import AppContainer from '../../../components/AppContainer/AppContainer'
import './ViewUserManual.scss'

function ViewUserManual() {
    const params = useParams()
    let id=params?.id ? parseInt(params?.id) : ''
    const dispatch = useDispatch()
    const {loading, userManualList} = useSelector(state => state?.getUserManualList);

    useEffect(() => {
      dispatch(viewUserManual())
    }, []);

  return (
    <AppContainer>
      <div className="view-UserManual"> 
        <Box className='h-100'>
          <Paper className='d-flex flex-column bg-dark' sx={{ width: '100%', borderRadius: 2, height: 'calc(100% - 90px)', overflow: 'hidden' }}>
            {
              loading ?
                <div className="text-center bg-dark pt-5 h-100 ">
                    <CircularProgress size={20} sx={{'color': '#5ebd78'}}/>
                </div>
                :
                // userManualList?.find(item=> item.id===id)?.url && <iframe  ref={iframeRef} width={'100%'} height={'100%'} src={`${userManualList?.find(item=> item.id===id)?.url}#toolbar=0`} frameborder="0"></iframe>
                <PDFViewer url={userManualList?.find(item=> item.id===id)?.url} />
            }
          </Paper>
        </Box>
      </div>
  </AppContainer>
  )
}

export default ViewUserManual